module.exports = __webpack_public_path__ + "img/rke.d10540bf.svg";